import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo, useState } from 'react';

import { useTrackInteraction } from '../hooks/useTracking';

export const ModalsContext = React.createContext({
    container: null,
});

export const useModalsContext = () => useContext(ModalsContext) || {};

export const useModals = () => {
    const { modal, setModal, unsetModal } = useContext(ModalsContext) || {};
    return { modal, setModal, unsetModal };
};

const propTypes = {
    children: PropTypes.node.isRequired,
    modal: PropTypes.shape({}),
    onClose: PropTypes.func,
};

export const ModalsProvider = ({ children = null, modal: initialModal = null, onClose = null }) => {
    const [modal, setModalState] = useState(initialModal);
    const trackInteraction = useTrackInteraction();

    const setModal = useCallback(
        (val) => {
            setModalState(val);
            if (trackInteraction !== null) {
                trackInteraction(
                    'modal',
                    'click',
                    val !== null ? 'open' : 'close',
                    val !== null ? val : 'empty',
                );
            }
        },
        [setModalState, trackInteraction],
    );

    const unsetModal = useCallback(
        (val) => {
            setModalState(null);
            if (onClose !== null) {
                const { type = null, id = null } = val || {};
                //  set cookie?
                onClose(type, id);
            }
            if (trackInteraction !== null) {
                trackInteraction('modal', 'click', 'close', 'empty');
            }
        },
        [setModalState, trackInteraction, onClose],
    );

    const value = useMemo(
        () => ({
            modal,
            setModal,
            unsetModal,
        }),
        [modal, setModalState, setModal, unsetModal],
    );
    return <ModalsContext.Provider value={value}>{children}</ModalsContext.Provider>;
};

ModalsProvider.propTypes = propTypes;
